<spinner-cover
  [isLoading]="isLoading"
></spinner-cover>
